import React from 'react';
import {
  Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InvButton from '../InvButton';
import { IPD_COLORS, cardSx } from '../../theme';

export default function MasterFormDialog({
  open,
  title,
  subtitle,
  onClose,
  formId,
  onSubmit,
  saving = false,
  submitLabel = 'Save',
  submitIcon,
  cancelLabel = 'Cancel',
  children,
  maxWidth = 'sm',
}) {
  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{ sx: cardSx }}
    >
      <DialogTitle
        sx={{
          color: IPD_COLORS.textPrimary,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          pr: 1,
          gap: 1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontWeight: 600, fontSize: 17, lineHeight: 1.3 }}>{title}</Typography>
          {subtitle && (
            <Typography sx={{ color: IPD_COLORS.textSecondary, fontSize: 13, mt: 0.5, fontWeight: 400 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose} disabled={saving} aria-label="Close" size="small" sx={{ mt: -0.25 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          component="form"
          id={formId}
          onSubmit={onSubmit}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 0.5 }}
        >
          {children}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <InvButton variant="outlined" tone="teal" onClick={onClose} disabled={saving}>
          {cancelLabel}
        </InvButton>
        <InvButton type="submit" form={formId} loading={saving} startIcon={submitIcon}>
          {submitLabel}
        </InvButton>
      </DialogActions>
    </Dialog>
  );
}
